import { useCallback, useState } from 'react';
import { TEMPORARY_RESOLVED_STATE_DURATION } from '../alarm-groups-list/constants';

export function useTemporaryResolvedState() {
  const [temporaryResolvedIds, setTemporaryResolvedIds] = useState<Set<string>>(
    new Set()
  );

  const addTemporaryResolvedState = useCallback((alarmGroupId: string) => {
    setTemporaryResolvedIds((prev) => new Set(prev).add(alarmGroupId));
    setTimeout(() => {
      setTemporaryResolvedIds((prev) => {
        const newSet = new Set(prev);
        newSet.delete(alarmGroupId);
        return newSet;
      });
    }, TEMPORARY_RESOLVED_STATE_DURATION);
  }, []);

  const getDisplayStatus = useCallback(
    (alarmGroupId: string, actualStatus: string): string => {
      return temporaryResolvedIds.has(alarmGroupId) ? 'resolved' : actualStatus;
    },
    [temporaryResolvedIds]
  );

  return {
    addTemporaryResolvedState,
    getDisplayStatus,
  };
}
